import css from '@styled-system/css';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const Columns = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['flexDirection', 'space'].includes(prop),
  })
  .attrs(({ flexDirection, space }) => ({
    flexDirection: flexDirection ?? {
      _: 'column',
      m: 'row',
      l: 'row',
    },
    space: space ?? 4,
  }))`
  > * + * {
    ${(props) =>
      // margin-left = 0 s / [space] m / [space] l
      // margin-top = [space] s / 0 m / 0 l
      css({
        ml: [0, props.space, props.space],
        mt: [props.space, 0, 0],
      })};
  }
`;

export const Column = styled(Box).attrs(({ width, ml }) => ({
  ml,
  display: 'block',
  width: width ?? { _: 1, m: 1 / 2, l: 1 / 2 },
}))``;

export default Columns;
